import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserRolesService } from '../../../app/services/user.roles.service';
import { EditDiscountItemRequest } from '../../../app/models/ss-api/requests/edit.discount.item.request';
import { AddNotePromptDialog } from '../add.note.prompt/add.note.prompt.dialog';
import { DeleteDiscountItemRequest } from '../../../app/models/ss-api/requests/delete.discount.item.request';
import { Router } from '@angular/router';

export interface IEditDiscountDialogModel {
    title: string;
    Discount: any;
    LicenseID?: number;
    MemberID?: number;
}

@Component({
    selector: 'edit-discount-dialog',
    styleUrls: ['./edit.discount.dialog.css'],
    templateUrl: './edit.discount.dialog.html'
})

export class EditDiscountDialog extends DialogComponent<IEditDiscountDialogModel, any> implements IEditDiscountDialogModel, OnInit {
    IsBusy: Boolean = false;
    title: string;
    Discount: any;
    LicenseID: number;
    MemberID: number;

    DiscountForm: FormGroup;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public roles: UserRolesService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.MemberID = this.LicenseID ? null : this.MemberID;
        this.LicenseID = this.MemberID ? null : this.LicenseID;

        this.DiscountForm = new FormGroup({
            'Amount': new FormControl(this.Discount.Amount, [Validators.required]),
            'Enabled': new FormControl(this.Discount.Enabled, [Validators.required]),
            'InvoiceDescription': new FormControl(this.Discount.InvoiceDescription, [Validators.required]),
            'KeepOnZeroInvoice': new FormControl(this.Discount.KeepOnZeroInvoice, [Validators.required]),
            'LicenseID': new FormControl(this.LicenseID, [Validators.required]),
            'MemberID': new FormControl(this.MemberID, [Validators.required]),
            'Month': new FormControl(this.Discount.Month, [Validators.required]),
            'Year': new FormControl(this.Discount.Year, [Validators.required]),
            'Reason': new FormControl(this.Discount.Reason, [Validators.required]),
        })
    }

    DeleteDiscount() {
        let dialog = this.dialogService.addDialog(AddNotePromptDialog, {
            title: 'Reason for Deleting Discount',
			subTitle: 'Please type a reason for deleting this discount',
			showCancel : true
        }, {
                width: 400,
                height: 500,
                IsRequired: true
            }).subscribe((noteResponse) => {
                let request: DeleteDiscountItemRequest = {
                    DiscountItemID: this.Discount.ID,
                    Reason: noteResponse
                }
                let disposable = this.api.DeleteDiscountItem(request).subscribe((response) => {

                    if (response.Result) {
                        this.result = {
                            isDeleted: true,
                            Discount: this.Discount
                        };
                        this.sweetAlert.swal({
                            type: 'success',
                            title: 'Deleted Discount',
                            text: 'Deleted discount successfully',
                            timer: 1500
                        }).then(() => { })
                    } else {
                        this.sweetAlert.swal({
                            type: 'error',
                            title: 'Error',
                            text: 'Could not delete discount.',
                            timer: 1500
                        }).then(() => { })
                    }

                    disposable.unsubscribe();
                    this.close();
                })
                dialog.unsubscribe();
            })
    }

    confirm() {
        this.IsBusy = true;
        let controls = this.DiscountForm.controls;

        if (this.Discount.KeepOnZeroInvoice == null) { this.Discount.KeepOnZeroInvoice = true; }

        let request: EditDiscountItemRequest = {
            DiscountItemID: this.Discount.ID,
            Amount: controls['Amount'].value,
            Enabled: controls['Enabled'].value,
            InvoiceDescription: controls['InvoiceDescription'].value,
            KeepOnZeroInvoice: controls['KeepOnZeroInvoice'].value ? controls['KeepOnZeroInvoice'].value : this.Discount.KeepOnZeroInvoice,
            LicenseID: this.LicenseID,
            MemberID: this.MemberID,
            Month: controls['Month'].value,
            Reason: controls['Reason'].value,
            Year: controls['Year'].value
        }

        let disposable = this.api.EditDiscountItem(request).subscribe(response => {
            if (response.Result) {
                this.result = {
                    isDeleted: false,
                    Discount: this.Discount
                };
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Discount Saved',
                    text: 'Discount saved successfully',
                    timer: 1500
                }).then(() => { this.close() })
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Discount Not Saved',
                    text: response.Message
                })
            }
            this.IsBusy = false;
            disposable.unsubscribe();
        })
    }

}
